import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { currencyOption, CompanyTransaction } from "../../../../../utility/data";
import moment from "moment";
import { getGroupsServices } from "../../../../../services/commonapi/commonApi";
import { useDispatch, useSelector } from "react-redux";
import { formatNumber } from "../../../../../utility/helper";
import { addTransaction, updateTransaction } from "../../../../../services/transaction";
import { fetchGroups, resetGroupsState } from "../../../../../redux/slices/groupsSlice";


const CreateTransactionModal = ({ visible, singleTransactionData, viewTransaction, GetstatsData, GetRoiData, actionTypes, fetchTransactionData, onHide, SelectType, loading, setLoading, toast, assetName, addItems, items }) => {
  const { groupsData, groupLoading } = useSelector((state) => state.groups);
  const { currency } = useSelector((state) => state.user);
  const filteredData = groupsData.filter(group => group.id == assetName?.included_in);
  const InitialDateValue = viewTransaction?.transactions?.find((item) => item.is_initial)

  const accessToken = JSON.parse(localStorage.getItem('access_token'));
  const initialTransactionData = {
    assetType: CompanyTransaction[0],
    includeIn: filteredData[0] ? filteredData[0] : groupsData[0],
    date: moment().toDate(),
    type: singleTransactionData?.type ? singleTransactionData?.type : SelectType,
    currency: currency ? currency : currencyOption[0].value,
    reason: singleTransactionData?.remark ? singleTransactionData?.remark : "",
    remark: singleTransactionData?.remark ? singleTransactionData?.remark : "",
    amount: singleTransactionData?.amount ? formatNumber(singleTransactionData?.amount) : "",
  };
  const [createTransactionData, setCreateTransactionData] = useState(initialTransactionData);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();


  useEffect(() => {
    if (singleTransactionData) {
      setCreateTransactionData((prevData) => ({
        ...prevData,
        currency: singleTransactionData.currency || prevData.currency,
        date: singleTransactionData.date ? moment(singleTransactionData.date).toDate() : prevData.date,
        reason: singleTransactionData.remark || "",
        amount: formatNumber(singleTransactionData.amount) || "",
        type: singleTransactionData.type || "",
      }));
    }
  }, [singleTransactionData]);

  useEffect(() => {
    if (currency && currency !== createTransactionData.currency) {
      setCreateTransactionData((prevData) => ({
        ...prevData,
        currency,
      }));
    }
  }, [currency]);

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchGroups(accessToken));
    }
    return () => {
      dispatch(resetGroupsState());
    };
  }, [dispatch, accessToken]);

  useEffect(() => {
    setCreateTransactionData((prevData) => ({
      ...prevData,
      type: singleTransactionData?.type ?? SelectType,
    }));
  }, [SelectType, visible]);


  useEffect(() => {
    if (groupsData?.length > 0) {
      setCreateTransactionData((prev) => ({
        ...prev,
        includeIn: filteredData[0] ? filteredData[0] : groupsData[0],
      }));
    }
  }, [groupsData, assetName]);

  const handleInputChange = (e) => {
    const { name, value } = e.target || e;

    setCreateTransactionData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name] && value && value.toString().trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };


  const handleAmountChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    let rawValue = value.replace(/[^0-9.-]/g, '');
    const decimalCount = (rawValue.match(/\./g) || [])?.length;
    if (decimalCount > 1) {
      return;
    }
    value = formatNumber(rawValue);

    let AutoCalPL = null;

    AutoCalPL = formatNumber(Number(rawValue));

    setCreateTransactionData((prevData) => ({
      ...prevData,
      amount: value,
      ...(AutoCalPL !== null && { amount: AutoCalPL })
    }));

    if (errors[name] && value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };


  const handleAssetTypeChange = (e) => {
    const selectedAssetType = e.value;

    setCreateTransactionData((prevData) => ({
      ...prevData,
      assetType: selectedAssetType,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!createTransactionData.date) {
      newErrors.date = "Date is required";
    }
    if (!createTransactionData.type) {
      newErrors.type = "Type is required";
    }
    if (!createTransactionData.currency) {
      newErrors.currency = "Currency is required";
    }

    if (!createTransactionData.includeIn) {
      newErrors.includeIn = "Groups is required";
    }
    if (!createTransactionData.amount) {
      newErrors.amount = "Amount is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSave = async () => {
    if (validateForm()) {
      setLoading(true);
      if (!assetName) {
        toast.current.show({
          className: 'bg-yellow-700 text-white',
          severity: 'warn',
          summary: 'Warning',
          detail: "Please add the first initial transaction",
          life: 3000,
        });
        return;
      }

      const formattedData = {
        ...createTransactionData,

        amount: createTransactionData.amount ? createTransactionData.amount.replace(/[,']/g, '') : '',
        type: createTransactionData.type ? createTransactionData.type : '',
        date: createTransactionData.date
          ? moment(createTransactionData.date).format('YYYY-MM-DD HH:mm:ss')
          : null,
      };
      try {
        const response = await (actionTypes === "Create"
          ? addTransaction(formattedData, assetName, accessToken)
          : updateTransaction(singleTransactionData.id, formattedData, assetName, accessToken));

        if (response.data.status === true) {
          fetchTransactionData();
          GetRoiData();
          GetstatsData();
          handleClose();
          toast.current.show({
            className: 'bg-green-300 text-white',
            severity: 'success',
            summary: 'Success',
            detail: response.data.message,
            life: 3000,
          });
        }
      } catch (error) {
        console.error('Error adding transaction:', error);
        toast.current.show({
          className: 'bg-yellow-700 text-white',
          severity: 'warn',
          summary: 'Warning',
          detail: error.message,
          life: 3000,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  if (!visible) return null;

  const handleClose = () => {
    setCreateTransactionData(initialTransactionData);
    setErrors({});
    onHide();
  };

  return (
    <div>
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-[rgba(44,52,79,1)] md:w-1/2 w-1/2 shadow-lg p-6 text-[rgba(255,255,255,1)]">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-2xl">{actionTypes} Transaction</h2>
            <FaTimes onClick={handleClose} className="cursor-pointer" fontSize={26} />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
            <div className="col-span-1 flex items-center gap-5 mb-4">
              <label className="text-sm font-medium text-white w-1/4">Asset Type</label>
              <Dropdown
                value={createTransactionData.assetType}
                name="assetType"
                onChange={handleAssetTypeChange}
                options={CompanyTransaction}
                disabled
                optionLabel="name"
                placeholder="Select asset type"
                className={`rounded-lg w-full p-0 bg-transparent border border-gray-300 text-white focus:outline-none focus:border-b-2 ${createTransactionData.assetType ? "asset_Dropdown" : ""}`}
              />
            </div>
            <div className="flex flex-col">
              <div className="col-span-1 flex items-center gap-5 mb-4">
                <label className="text-sm font-medium text-white w-1/4">Include In*</label>
                <Dropdown
                  value={createTransactionData.includeIn}
                  name="includeIn"
                  onChange={(e) => handleInputChange({ name: "includeIn", value: e.value })}
                  options={groupsData}
                  disabled
                  optionLabel="name"
                  className={`w-full p-0 bg-transparent border border-gray-300 text-white rounded-lg focus:outline-none focus:border-b-2 ${createTransactionData.includeIn ? "asset_Dropdown" : ""}`}
                />
              </div>
              {errors.includeIn && <small className="text-red-500 text-center mt-[-10px]">{errors.includeIn}</small>}
            </div>
            <div className="flex flex-col">
              <div className="col-span-1 flex items-center gap-5 mb-4">
                <label className="text-sm font-medium text-white w-1/4">Date*</label>
                <Calendar
                  value={createTransactionData.date}
                  onChange={(e) => handleInputChange({ name: "date", value: e.value })}
                  dateFormat="dd/mm/yy"
                  className="asset_date w-full"
                  minDate={InitialDateValue?.date ? moment(InitialDateValue.date).toDate() : moment().toDate()}
                  maxDate={moment().toDate()}
                  disabled={actionTypes === "Update"}
                />
              </div>
              {errors.date && <small className="text-red-500 text-center mt-[-10px]">{errors.date}</small>}
            </div>

            <div className="flex flex-col">
              <div className="col-span-1 flex items-center gap-5 mb-4">
                <label className="text-sm font-medium text-white w-1/4">Type*</label>
                <input
                  type="text"
                  name="type"
                  value={createTransactionData.type}
                  onChange={handleInputChange}
                  disabled
                  autoComplete="off"
                  className="block w-full bg-transparent border-b disabled:text-gray-500 border-gray-300 text-white focus:outline-none focus:border-b-2"
                />
              </div>
              {errors.type && <small className="text-red-500 text-center mt-[-10px]">{errors.type}</small>}
            </div>

            <div className="flex flex-col">
              <div className="col-span-1 flex items-center gap-5 mb-4">
                <label className="text-sm font-medium text-white w-1/4">Reason</label>
                <input
                  type="text"
                  name="reason"
                  value={createTransactionData.reason}
                  onChange={handleInputChange}
                  autoComplete="off"
                  className="block w-full bg-transparent border-b border-gray-300 text-white focus:outline-none focus:border-b-2"
                />
              </div>
              {errors.reason && <small className="text-red-500 text-center mt-[-10px]">{errors.reason}</small>}
            </div>
            <div className="flex md:flex-col flex-row">
              <div className="col-span-1 md:flex items-center gap-5 mb-4">
                <label className="text-sm font-medium text-white w-1/4">Currency*</label>
                <Dropdown
                  value={createTransactionData.currency}
                  name="currency"
                  onChange={handleInputChange}
                  disabled
                  options={currencyOption}
                  optionLabel="label"
                  optionValue="value"
                  className={`create_transaction w-full p-0 bg-transparent border-b border-gray-300 text-white rounded-none focus:outline-none focus:border-b-2 ${createTransactionData.currency ? "asset_Dropdown" : ""}`}
                />
              </div>
              {errors.currency && <small className="text-red-500 text-center mt-[-10px]">{errors.currency}</small>}
            </div>
            <div className="flex flex-col">
              <div className="col-span-1 flex gap-5 mb-4">
                <label className="text-sm font-medium text-white capitalize w-1/4">Amount*</label>
                <input
                  type="text"
                  name="amount"
                  value={createTransactionData.amount}
                  onChange={handleAmountChange}
                  className="block w-full bg-transparent border-b border-gray-300 text-white focus:outline-none focus:border-b-2"
                />
              </div>
              {errors.amount && <small className="text-red-500 text-center mt-[-10px]">{errors.amount}</small>}
            </div>

          </div>

          <div className="mt-4 flex gap-2">
          <button
              disabled={loading}
              onClick={handleSave}
              className={`bg-secondary text-primary px-4 py-2 rounded ${loading ? 'bg-gray-600 opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading ? 'Saving...' : actionTypes === "Create" ? 'Save' : 'Update'}
            </button>
            <button
              onClick={handleClose}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTransactionModal;
